let config = {
    currency: 'TZS',
    mapStartingPoint:[-2.500381, 32.889060],
    env : 'production',
}

export { config }
